exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chip {\n\tpadding: 10px;\n\tbackground-color: #eee;\n\tborder-radius: 10px;\n\tmargin-left: 5px;\n}\n\n.active-user-warning {\n\tfont-style: italic;\n\tcolor: #bbb;\n}\n", ""]);

// exports
